"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M11 7H9V5c0-.55-.45-1-1-1s-1 .45-1 1v2H5c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V9h2c.55 0 1-.45 1-1s-.45-1-1-1z"];
//# sourceMappingURL=small-plus.js.map